import type { AuthProvider } from '@refinedev/core'

/**
 * Auth provider Refine.
 * Utilise l'auth session existante (OIDC) — verifie le role requis.
 */
export const authProvider = (apiUrl: string, requiredRole = 'ADMIN_ATTESTATION'): AuthProvider => ({
  check: async () => {
    try {
      const res = await fetch(`${apiUrl}/auth/me`, { credentials: 'include' })
      if (res.ok) {
        const user = await res.json()
        if (user.roles?.includes(requiredRole)) {
          return { authenticated: true }
        }
      }
      return { authenticated: false, redirectTo: '/' }
    } catch {
      return { authenticated: false, redirectTo: '/' }
    }
  },

  getPermissions: async () => {
    try {
      const res = await fetch(`${apiUrl}/auth/me`, { credentials: 'include' })
      if (res.ok) {
        const user = await res.json()
        return user.roles || []
      }
      return []
    } catch {
      return []
    }
  },

  getIdentity: async () => {
    try {
      const res = await fetch(`${apiUrl}/auth/me`, { credentials: 'include' })
      if (res.ok) {
        return await res.json()
      }
      return null
    } catch {
      return null
    }
  },

  // L'auth est geree par OIDC, pas par Refine
  login: async () => ({ success: true }),
  logout: async () => ({ success: true, redirectTo: '/' }),
  onError: async (error) => ({ error }),
})
